import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCloudWeather: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1-IconCloudWeather"><Path d="M8.85 4C4.50509 4 1 7.59129 1 12C1 16.4087 4.50509 20 8.85 20H17.25C20.4351 20 23 17.3681 23 14.1429C23 10.9176 20.4351 8.28571 17.25 8.28571C16.9761 8.28571 16.7064 8.30526 16.4422 8.34313C16.1104 8.39069 15.7838 8.23386 15.6332 7.97104C14.2745 5.59998 11.7481 4 8.85 4Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCloudWeather;
